// The colours every layout type starts with for a NEW client, and for every workspace that has
// never saved its brand. Omar, 2026-10-20 (wiki Brand_design §2 D13): "capture the colors I set on
// the 32_Dynamo-Brand-prototype-2026-10-20.html … as I want you to use these colors as default
// colors for every new client".
//
// Where each value comes from:
//   · 108 of the 121 are HIS, read from his open prototype tab on 2026-10-20 (the file
//     `raw/_Dynamo Fixes/32_Dynamo-my-brand-colours.json` in the wiki), with his rules of
//     2026-10-21 applied (D18: #333333 and #080808 → #000000; #F2F2F2 and #F5F5F5 → #F8F8F8);
//   · the 13 that no view of the prototype shows (D35: the markers inside Sequence and
//     Horizontal tabs videos, the 3D viewer's hotspot, the quiz hotspots) keep the starting
//     colours the app gave them before this change.
//
// `brand.test.ts` holds this table to the colour registry both ways: every type, every path,
// nothing else.
//
// Not derived at run time from anything: these are decisions, not computations.
export const FACTORY_WORKSPACE_BRAND_LAYOUTS = {
    fullscreen_text_and_image: {
        "titleTextColor": "#FFFFFF",
        "textColor": "#FFFFFF",
        "contentBackgroundColor": "#000000",
        "blockingSection.color": "#000000",
        "blockingSection.textColor": "#FFFFFF",
    },
    title: {
        "titleTextColor": "#FFFFFF",
        "titleBackgroundColor": "#000000",
        "blockingSection.color": "#FFFFFF",
        "blockingSection.textColor": "#000000",
    },
    two_columns_text: {
        "titleTextColor": "#000000",
        "titleBackgroundColor": "#FFFFFF",
        "leftColumnBackgroundColor": "#97C3CB",
        "leftColumnTextColor": "#000000",
        "rightColumnBackgroundColor": "#2D6396",
        "rightColumnTextColor": "#FFFFFF",
        "blockingSection.color": "#F8F8F8",
        "blockingSection.textColor": "#000000",
    },
    text_and_image: {
        "titleTextColor": "#000000",
        "titleBackgroundColor": "#F8F8F8",
        "rows.*.backgroundColor": "#FFFFFF",
        "rows.*.textColor": "#000000",
        "blockingSection.color": "#F8F8F8",
        "blockingSection.textColor": "#000000",
    },
    small_video: {
        "titleTextColor": "#FFFFFF",
        "titleBackgroundColor": "#000000",
        "contentBackgroundColor": "#000000",
        "interactions.*.borderColor": "#2D6396",
        "interactions.*.bgColor": "#F8F8F8",
        "interactions.*.textColor": "#000000",
        "blockingSection.color": "#000000",
        "blockingSection.textColor": "#FFFFFF",
    },
    fullscreen_video: {
        "titleTextColor": "#FFFFFF",
        "titleBackgroundColor": "#000000",
        "interactions.*.borderColor": "#2D6396",
        "interactions.*.bgColor": "#FFFFFF",
        "interactions.*.textColor": "#000000",
        "blockingSection.color": "#000000",
        "blockingSection.textColor": "#FFFFFF",
    },
    sequence: {
        "titleTextColor": "#FFFFFF",
        "titleBackgroundColor": "#000000",
        "contentBackgroundColor": "#000000",
        "tabs.*.bgColor": "#FFFFFF",
        "tabs.*.textColor": "#000000",
        "tabs.*.btnBgColor": "#2D6396",
        "tabs.*.btnTextColor": "#FFFFFF",
        "tabs.*.interactions.*.borderColor": "#2D6396",
        "tabs.*.interactions.*.bgColor": "#000000",
        "tabs.*.interactions.*.textColor": "#FFFFFF",
        "dotSelectedColor": "#2D6396",
        "blockingSection.color": "#000000",
        "blockingSection.textColor": "#FFFFFF",
    },
    vertical_tabs: {
        "titleTextColor": "#000000",
        "contentBackgroundColor": "#FFFFFF",
        "selectedBgColor": "#2D6396",
        "blockingSection.color": "#FFFFFF",
        "blockingSection.textColor": "#000000",
    },
    icons_discover: {
        "titleTextColor": "#FFFFFF",
        "titleBackgroundColor": "#000000",
        "contentBackgroundColor": "#000000",
        "selectedBgColor": "#2D6396",
        "blockingSection.color": "#000000",
        "blockingSection.textColor": "#FFFFFF",
    },
    horizontal_tabs: {
        "titleTextColor": "#000000",
        "titleBackgroundColor": "#FFFFFF",
        "selectedBgColor": "#2D6396",
        "selectedTextColor": "#FFFFFF",
        "tabTextColor": "#000000",
        "tabs.*.interactions.*.borderColor": "#97C3CB",
        "tabs.*.interactions.*.bgColor": "#FFFFFF",
        "tabs.*.interactions.*.textColor": "#000000",
        "blockingSection.color": "#FFFFFF",
        "blockingSection.textColor": "#000000",
    },
    hidden_items: {
        "titleTextColor": "#FFFFFF",
        "titleBackgroundColor": "#000000",
        "contentBackgroundColor": "#000000",
        "itemColor": "#2D6396",
        "bgColor": "#F8F8F8",
        "borderColor": "#2D6396",
        "textColor": "#000000",
        "blockingSection.color": "#000000",
        "blockingSection.textColor": "#FFFFFF",
    },
    object_viewer: {
        "titleTextColor": "#FFFFFF",
        "backgroundColor": "#000000",
        "itemColor": "#2D6396",
        "bgColor": "#FFFFFF",
        "borderColor": "#97C3CB",
        "textColor": "#000000",
        "blockingSection.color": "#F8F8F8",
        "blockingSection.textColor": "#000000",
    },
    quiz_images: {
        "titleTextColor": "#FFFFFF",
        "titleBackgroundColor": "#000000",
        "contentBackgroundColor": "#000000",
        "contentTextColor": "#FFFFFF",
        "selectedBgColor": "#2D6396",
        "selectedTextColor": "#FFFFFF",
        "dotSelectedColor": "#2D6396",
        "questions.*.content.itemColor": "#2D6396",
        "questions.*.content.bgColor": "#F8F8F8",
        "questions.*.content.borderColor": "#97C3CB",
        "questions.*.content.textColor": "#000000",
        "blockingSection.color": "#000000",
        "blockingSection.textColor": "#FFFFFF",
    },
    quiz_gaming: {
        "titleTextColor": "#FFFFFF",
        "titleBackgroundColor": "#000000",
        "contentBackgroundColor": "#000000",
        "contentTextColor": "#FFFFFF",
        "selectedBgColor": "#2D6396",
        "selectedTextColor": "#FFFFFF",
        "dotSelectedColor": "#2D6396",
        "gamingStartScreen.bgColor": "#000000",
        "gamingStartScreen.titleColor": "#FFFFFF",
        "gamingEndScreens.win.bgColor": "#000000",
        "gamingEndScreens.win.titleColor": "#FFFFFF",
        "gamingEndScreens.failure.bgColor": "#000000",
        "gamingEndScreens.failure.titleColor": "#FFFFFF",
        "questions.*.content.itemColor": "#2D6396",
        "questions.*.content.bgColor": "#F8F8F8",
        "questions.*.content.borderColor": "#97C3CB",
        "questions.*.content.textColor": "#000000",
        "blockingSection.color": "#000000",
        "blockingSection.textColor": "#FFFFFF",
    },
};
//# sourceMappingURL=brand-factory-layouts.js.map